import { Ecommerce } from "../../../../../tracking/ga4/events/ecommerce";
import { Currency } from "../../../../../app-settings/localesAndCurrencies";
import { ClaimType, PotentialRegulation } from "../../../types/intake-funnel";
import { getFunnelTrack } from "../../track/utils";
import { sessionTime } from "../../../../../tracking/utils/sessionTime";

// TODO: Extend with more variant when post-eligibility will be implemented
export function buildEcommerce({
  currency,
  claimType,
  airlineName,
  previousFunnel,
  potentialRegulation,
}: {
  currency: Currency;
  claimType?: ClaimType;
  airlineName?: string;
  previousFunnel?: string;
  potentialRegulation?: PotentialRegulation;
}): Ecommerce {
  return {
    currency,
    transaction_id: "",
    claim_type: claimType,
    total_time_claim: sessionTime.getDuration(),
    items: [
      {
        quantity: 1,
        item_brand: "AirHelp",
        item_variant: "Regular",
        item_name: getFunnelTrack(),
        item_category: potentialRegulation,
        item_category2: airlineName,
        item_category3: previousFunnel,
        item_category4: "",
        item_category5: "Default",
        affiliation: "AirHelp",
        claim_type: claimType,
      },
    ],
  };
}
